@if (mappedData) {
  @for (keyVal of orderedKeys; track keyVal) {
    @if (keyVal !== 'fieldBlocks' && keyVal !== 'fieldEhisLinks') {
      @if (mappedData[keyVal] && collection[keyVal] && !(keyVal === 'fieldJobs' && !mappedData[keyVal].length) && !mappedData[keyVal]?.conditionalRender) {
        <block theme="sidebar">
          @if (!titleLess[collection[keyVal]]) {
            <block-title [ngClass]="'type-'+[collection[keyVal]]">
              <h2>{{ (keyVal === 'event' ? 'event.label' : keyVal) | translate }}</h2>
              @if (keyVal === 'notifications' && mappedData.notifications.unread > 0) {
                <div class="unreadMessages">
                  {{mappedData.notifications.unread}}
                </div>
              }
            </block-title>
          }
          <block-content>
            @switch (collection[keyVal]) {
              @case ('gdpr') {
                <sidebar-gdpr [data]="mappedData[keyVal]"></sidebar-gdpr>
              }
              @case ('notifications') {
                <sidebar-notifications [data]="mappedData[keyVal]"></sidebar-notifications>
              }
              @case ('links') {
                <sidebar-links [data]="mappedData[keyVal]"></sidebar-links>
              }
              @case ('categories') {
                <sidebar-categories [data]="mappedData[keyVal]"></sidebar-categories>
              }
              @case ('contact') {
                <sidebar-contact [data]="mappedData[keyVal]" [type]="type"></sidebar-contact>
              }
              @case ('actions') {
                <sidebar-actions [data]="isArray(mappedData[keyVal]) ? mappedData[keyVal] : [mappedData[keyVal]]"></sidebar-actions>
              }
              @case ('articles') {
                <sidebar-articles [data]="mappedData[keyVal]"></sidebar-articles>
              }
              @case ('news') {
                <sidebar-articles [data]="mappedData[keyVal]"></sidebar-articles>
              }
              @case ('data') {
                <sidebar-data [data]="mappedData[keyVal]"></sidebar-data>
              }
              @case ('location') {
                <sidebar-location [data]="mappedData[keyVal]"></sidebar-location>
              }
              @case ('facts') {
                <sidebar-facts [data]="mappedData[keyVal]" [theme]="type"></sidebar-facts>
              }
              @case ('progress') {
                <sidebar-progress [data]="mappedData[keyVal]"></sidebar-progress>
              }
              @case ('register') {
                <sidebar-register [data]="mappedData[keyVal]" [pageData]="data"></sidebar-register>
              }
              @case ('events') {
                <sidebar-events [data]="mappedData[keyVal]"></sidebar-events>
              }
              @case ('finalDocumentAccess') {
                <sidebar-finaldocument-access [data]="mappedData[keyVal]"></sidebar-finaldocument-access>
              }
              @case ('finalDocumentHistory') {
                <sidebar-finaldocument-history [data]="mappedData[keyVal]"></sidebar-finaldocument-history>
              }
              @case ('finalDocumentDownload') {
                <sidebar-finaldocument-download [data]="mappedData[keyVal]"></sidebar-finaldocument-download>
              }
              @case ('downloadFile') {
                <sidebar-download-file [data]="mappedData[keyVal]"></sidebar-download-file>
              }
            }
          </block-content>
        </block>
      }
      @if (mappedData[keyVal]?.conditionalRender) {
        @if (collection[keyVal] === 'downloadFile') {
          <sidebar-download-file [data]="mappedData[keyVal]"></sidebar-download-file>
        }
      }
    }
    @if ((keyVal === 'fieldBlocks' || keyVal === 'fieldEhisLinks') && mappedData[keyVal]) {
      <sidebar-links [data]="mappedData[keyVal]"></sidebar-links>
    }
  }
  @if (feedbackNid) {
    <feedback [nid]="feedbackNid"></feedback>
  }
}
